import Steps from './Steps';
import Step from './Step';
import StepGroup from './StepGroup'

Steps.Step = Step;
Steps.StepGroup = StepGroup;

export { Step };
export { StepGroup };
export default Steps;
